
import React, { Component } from 'react';
import { Modal, Form, Row, Button, Table, Descriptions, Tooltip } from 'antd';

class ChapterApplyAuditForm extends Component {

    columns = [{
        title: '审核人',
        dataIndex: 'username',
        width: '10%',
    }, {
        title: '审核时间',
        dataIndex: 'auditTime',
        width: '15%',
    }, {
        title: '审核意见',
        dataIndex: 'opinion',
        width: '10%',
        render: (text) => text === 1 ? "同意" : "不同意"
    }, {
        title: '备注说明',
        dataIndex: 'remark',
        width: '20%',
        render: (text) => <Tooltip title={text}>
            <span>{text}</span>
        </Tooltip>
    }, {
        title: '审核节点',
        dataIndex: 'status',
        width: '15%',
        render: (text) => this.props.auditStatus[text]
    }];

    render() {
        const { visible, onCancel, editData } = this.props;
        return (
            <Modal
                width={800}
                visible={visible}
                title="用章申请审核详情"
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                footer={[
                    <Button key="ok" type="primary" onClick={onCancel}>确定</Button>,
                ]}
            >
                <div>
                    <Descriptions column={2} bordered>
                        <Descriptions.Item label="申请名称">{editData["flowName"]}</Descriptions.Item>
                        <Descriptions.Item label="描述信息">{editData["des"]}</Descriptions.Item>
                        <Descriptions.Item label="创建时间">{editData["insertTime"]}</Descriptions.Item>
                        <Descriptions.Item label="创建人">{editData["creator"]}</Descriptions.Item>
                    </Descriptions>
                    <Row style={{ marginTop: '10px' }}>
                        <Table rowKey="id" columns={this.columns} dataSource={this.props.auditList} pagination={false} />
                    </Row>
                </div>
            </Modal>
        );
    }
}

const ChapterApplyAudit = Form.create()(ChapterApplyAuditForm);

export default ChapterApplyAudit;